import { ORGANIZATION } from '../constants';
import getDatasetSchema from './get-dataset-schema';
import getFaqSchema from './get-faq-schema';
import getInsuranceOfferV2Schema from './get-insurance-offer-v2-schema';
import getMinimumStarRatingOnSERPsSchema from './get-minimum-start-rating-on-serps-schema';
import getReviewRatingSchema from './get-review-rating-schema';
/**
 * Get the schema for Organization
 *
 * @return {Object} Organization schema
 */

export var getOrganizationSchema = ORGANIZATION;
export { getFaqSchema, getInsuranceOfferV2Schema, getMinimumStarRatingOnSERPsSchema, getReviewRatingSchema, getDatasetSchema };